/** Person explicitly opted in or out of Maz */
export enum MazStatus {
  ENABLED = 'ENABLED',
  DISABLED = 'DISABLED',
}
